import React from "react";
import { useQuery } from "@apollo/client";
import { GET_USER_STATE } from "api/graphql/queries";
import PerformanceAnalysisLandingHeader from "./PerformanceAnalysisLandingHeader";
import PerformanceAnalysisLandingPreview from "./PerformanceAnalysisLandingPreview";
import PerformanceAnalysisLandingFAQ from "./PerformanceAnalysisLandingFAQ";
import { directToPage } from "lib/redirect-helpers";
import CHECK_YIR_STATUS from "components/Pages/PerformanceReview/queries/checkYearInReviewStatus";

const processingStatuses = ["processing", "enqueued"];

const PerformanceAnalysisLandingPage = (props) => {
  const { loading: isUserStateLoading, error, data: userState } = useQuery(GET_USER_STATE, { fetchPolicy: "network-only" });
  const directToYIR = directToPage("performanceAnalysis");

  // TODO remove hard-coding the season
  const { data: yirStatus, loading: isYIRStatusLoading } = useQuery(CHECK_YIR_STATUS, {
    variables: {
      regionId: userState ? userState.getState.lolSettings.summoners[0].regionId : "na1",
      summonerName: userState ? userState.getState.lolSettings.summoners[0].summonerName : "",
      season: 14,
    },
    fetchPolicy: "network-only",
    skip: !userState || isUserStateLoading,
  });

  const isYIRStatusProcessing = yirStatus && processingStatuses.includes(yirStatus.summonerReviewStatus.status);

  if (isUserStateLoading || isYIRStatusLoading) {
    return (
      <div className="performance-analysis_landing-page performance-analysis_landing-page_loading">
        <div className="spinthatshit-loader"></div>
      </div>
    );
  }

  // If this year in review is generating, route to perfAnalysis and we'll render the loading widget there.
  if (isYIRStatusProcessing) {
    directToYIR();
  }

  if (userState && !isUserStateLoading) {
    const { summonerName, regionId, verified } = userState.getState.lolSettings.summoners[0];
    const { isPremium } = userState.getState.premium;

    return (
      <div className="performance-analysis_landing-page">
        <PerformanceAnalysisLandingHeader
          summonerName={summonerName}
          regionId={regionId}
          isVerified={verified}
          isPremium={isPremium}
        />
        <PerformanceAnalysisLandingPreview />
        <PerformanceAnalysisLandingFAQ />
      </div>
    );
  } else if (!isUserStateLoading) {
    return (
      <div className="performance-analysis_landing-page">
        <PerformanceAnalysisLandingHeader isVerified={false} isPremium={false} />
        <PerformanceAnalysisLandingPreview />
        <PerformanceAnalysisLandingFAQ />
      </div>
    );
  } else {
    return <div />;
  }
};

export default PerformanceAnalysisLandingPage;
